import { isEmpty, toLower } from 'lodash';

import { revertPhoneMask } from 'helpers/revert-phone-mask';

import axios from 'axios';
import { axiosDelete, axiosGet, axiosPatch, axiosPost } from './axios.helpers';

const baseUrl = `${process.env.REACT_APP_API_URL}/v1`;
const token = localStorage.getItem('token');

export const getOrganizations = async (pageNumber, pageSize) =>
  axiosGet(
    `/organizations?page[number]=${pageNumber + 1}&page[size]=${pageSize}`,
  );

export const showOrganization = async (id) => axiosGet(`/organizations/${id}`);

export const updateOrganization = async (id, organization) => {
  const {
    name,
    shortName,
    contactFirstName,
    contactLastName,
    contactTitle,
    contactEmail,
    contactPhone,
    address,
    city,
    state,
    postalCode,
    country,
    billingId,
    accountManagerId,
  } = organization;

  await axiosPatch(`/organizations/${id}`, {
    name,
    short_name: toLower(shortName),
    address,
    city,
    ...(isEmpty(contactFirstName)
      ? {}
      : { contact_first_name: contactFirstName }),
    ...(isEmpty(contactLastName) ? {} : { contact_last_name: contactLastName }),
    ...(isEmpty(contactEmail) ? {} : { contact_email: contactEmail }),
    ...(isEmpty(contactTitle) ? {} : { contact_title: contactTitle }),
    billing_id: billingId,
    state,
    postal_code: postalCode,
    country,
    ...(isEmpty(contactPhone)
      ? {}
      : { contact_phone: revertPhoneMask(contactPhone) }),
    ...(isEmpty(accountManagerId.toString())
      ? {}
      : { acc_mgr: accountManagerId }),
  });
};

export const createOrganization = async (organization) => {
  const {
    name,
    shortName,
    contactFirstName,
    contactLastName,
    contactPhone,
    contactTitle,
    contactEmail,
    address,
    city,
    state,
    postalCode,
    country,
    billingId,
    accountManagerId,
  } = organization;

  return axiosPost('/organizations', {
    name,
    short_name: toLower(shortName),
    ...(isEmpty(contactFirstName)
      ? {}
      : { contact_first_name: contactFirstName }),
    ...(isEmpty(contactLastName) ? {} : { contact_last_name: contactLastName }),
    ...(isEmpty(contactEmail) ? {} : { contact_email: contactEmail }),
    ...(isEmpty(contactTitle) ? {} : { contact_title: contactTitle }),
    billing_id: billingId,
    address,
    city,
    state,
    postal_code: postalCode,
    country,
    ...(isEmpty(contactPhone)
      ? {}
      : { contact_phone: revertPhoneMask(contactPhone) }),
    ...(isEmpty(accountManagerId) ? {} : { acc_mgr: accountManagerId }),
  });
};

export const uploadOrgLogo = async (id, logo) => {
  const formData = new FormData();
  formData.append('logo', logo);

  await axios.post(`${baseUrl}/organizations/${id}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const deleteOrganization = async (id) => {
  await axiosDelete(`/organizations/${id}`);
};
